import { render, staticRenderFns } from "./GraphDashboard.vue?vue&type=template&id=b83a12f4&"
import script from "./GraphDashboard.vue?vue&type=script&lang=js&"
export * from "./GraphDashboard.vue?vue&type=script&lang=js&"
import style0 from "@/components/GRAPH/Dashboard/CSS/Dashboard.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports